var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"card-element"}}),_c('div',{staticClass:"text-danger",attrs:{"id":"card-errors","role":"alert"}})])
}]

export { render, staticRenderFns }